import script from "./DevDocsCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./DevDocsCenter.vue?vue&type=script&setup=true&lang=js"

import "./DevDocsCenter.vue?vue&type=style&index=0&id=6f8552f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8552f4"]])

export default __exports__